export const APP_VERSION = 'mobile-2026.09.23.183806';
export const APP_NAME = 'mobile';
